import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ReportCacheService } from 'core';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { loadCache, loadCacheSuccess, loadCacheFail } from '../actions';
import { of } from 'rxjs';

@Injectable()
export class ReportCacheEffects {

    constructor(
        private actions$: Actions,
        private rs: ReportCacheService
    ) { }

    loadCache$ = createEffect(() => this.actions$.pipe(
        ofType(loadCache),
        exhaustMap(action => {
            return this.rs.getCache(action.cacheKey).pipe(
                map(cache => loadCacheSuccess({ cache })),
                catchError(err => of(loadCacheFail(err)))
            )
        })
    ));

}